import { seedConfigFromSample } from "../../../../Routes/RenderPdf/seedConfig";

export function loadReportDataStarted(state, payload) {
  return {
    isProcessing: true,
    error: null,
    isDataFetched: false
  };
}

export function loadReportDataSuccess(state, payload) {
  var stored = payload && payload.data && payload.data.data && payload.data.data.data && payload.data.data.data.reportConfiguration;
  if (stored && Array.isArray(stored)) {
    // Re-seed stored data so any newly-added editable keys get defaults
    // even if the saved blob predates them.
    return {
      data: stored,
      isProcessing: false,
      dirty: false,
      error: null,
      isDataFetched: true
    };
  }
  return {
    isProcessing: false,
    error: null,
  };
}

export function loadReportDataFailed(state, payload) {
  // Baseline is already in state — ignore the error silently, matching the
  // original context behavior.
  return {
    isProcessing: false,
    isDataFetched: false
  };
}
